/**
 * Legenda completa do gráfico do M6 (fiel ao protótipo): leitura + Níveis de
 * Controle + cotas + overlays. DOM puro (sempre renderiza; testável sem SVG).
 */
import type { ChartModel } from '../domain/chart-model';
import { AXIS, EIXO_B_COLOR, PLUV_COLOR, REGUA_COLOR } from './chart-theme';

function LegendItem({ label, color, variant }: { label: string; color: string; variant: 'line' | 'dashed' | 'bar' }) {
  const swatch = variant === 'bar'
    ? <span style={{ display: 'inline-block', width: 12, height: 8, background: color, opacity: 0.45, borderRadius: 1 }} />
    : <span style={{ display: 'inline-block', width: 16, height: 0, borderTop: `2px ${variant === 'dashed' ? 'dashed' : 'solid'} ${color}` }} />;
  return <span className="inline-flex items-center gap-1">{swatch}{label}</span>;
}

export default function ChartLegend({ model, color }: { model: ChartModel; color: string }) {
  return (
    <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 text-[10px] mt-1" style={{ color: AXIS }}>
      {/* GUPM-270 — com duas séries, "Leitura" não identifica nenhuma das duas: o
          gráfico do tiltímetro tem uma curva por eixo, e sem nomeá-las a legenda
          deixaria o RT sem saber qual inclinação está olhando. */}
      <LegendItem
        label={model.hasEixoB ? `Eixo A (${model.unit})` : `Leitura (${model.unit || 'un.'})`}
        color={color}
        variant="line"
      />
      {model.hasEixoB && (
        <LegendItem label={`Eixo B (${model.unit})`} color={EIXO_B_COLOR} variant="dashed" />
      )}
      {model.referenceLines.map((l) => (
        <LegendItem key={l.label} label={l.label} color={l.color} variant={l.kind === 'threshold' ? 'dashed' : 'line'} />
      ))}
      {model.hasRegua && <LegendItem label="Régua do reservatório" color={REGUA_COLOR} variant="line" />}
      {model.hasPluviometria && <LegendItem label="Pluviometria (mm)" color={PLUV_COLOR} variant="bar" />}
    </div>
  );
}
